// extracted by mini-css-extract-plugin
module.exports = {"atendimentoConsulta":"Consultar_atendimentoConsulta__PAvye","containerPainel":"Consultar_containerPainel__5h2sy"};